<template>
    <div class="container">
        <!-- 转盘组件 -->
        <!-- <div @click="maskShow" class="dialog"></div> -->

        <div class="brand-logo"></div>
        <template v-if="!maskSymbol">
            <div class="active-logo"></div>
        </template>
        <div class="mask-wrapper">
            <template v-if="maskSymbol">
                <div :style="maskStyle"></div>
            </template>

            <template v-if="maskSymbol"
                ><!-- true -->
                <!-- 这这这 -->
                <div class="prize">
                    <template v-if="maskFlags">
                        <img
                            class="under-img"
                            src="../assets/img/装饰金币_上_外侧@2x.png"
                            alt=""
                        />
                        <!-- 测试下面需打开 -->
                        <img class="prize-img" :src="imgSrc" alt="" />
                        <!-- <img class="prize-img" src="../assets/img/prizeFree.png" alt=""> -->
                        <img
                            class="below-img"
                            src="../assets/img/装饰金币_里侧@2x.png"
                            alt=""
                        />
                        <img
                            class="could-one"
                            src="../assets/img/祥云_上@2x.png"
                            alt=""
                        />
                        <img
                            class="could-two"
                            src="../assets/img/祥云_下@2x.png"
                            alt=""
                        />
                        <p style="font-size: 0.33rem;" class="text-alert">
                            剩余{{
                                userTimesObj.leftCount
                                    ? userTimesObj.leftCount
                                    : 0
                            }}次
                        </p>
                        <img
                            class="invite-friends"
                            src="../assets/img/邀请好友@2x.png"
                            alt=""
                        />
                        <input
                            class="input-phone"
                            type="text"
                            v-model="userPhone"
                            placeholder="请输入手机号"
                        />
                        <!-- 验证码 + 图片 -->
                        <template v-if="verifyFlag">
                            <input
                                class="verify-ipt"
                                type="text"
                                v-model="userWrite"
                                placeholder="请输入右侧图中的内容"
                            />
                            <img class="verify-img" :src="captchaUrl" />
                        </template>
                        <input
                            v-model="userVerificationCode"
                            :class="{
                                'submit-phone': !verifyFlag,
                                'submit-phone2': verifyFlag,
                            }"
                            type="text"
                            placeholder="请输入验证码"
                        />
                        <button
                            @click="
                                getVerifyFlag && getVerify();
                                !getVerifyFlag && getVerify2();
                            "
                            style="font-size: 30px;"
                            :class="{
                                'input-verify': !verifyFlag,
                                'input-verify2': verifyFlag,
                            }"
                        >
                            {{ content }}
                        </button>
                        <button
                            @click="getNow"
                            :class="{
                                'get-now': !verifyFlag,
                                'get-now2': verifyFlag,
                            }"
                        ></button>
                    </template>
                </div>
            </template>
        </div>

        <!-- turnTable -->
        <template v-if="!maskSymbol">
            <div class="wrapper">
                <div class="turntable">
                    <div class="left-star"></div>
                    <!-- 点击时候转动转盘 指针不转 -->
                    <div
                        class="outer-circle"
                        :style="{
                            transform: rotateAngle,
                            transition:
                                rotateTransition == ''
                                    ? 'transform 7s ease-in-out'
                                    : rotateTransition,
                        }"
                    ></div>
                    <div
                        class="inside-circle"
                        :style="{
                            transform: rotateAngle,
                            transition:
                                rotateTransition == ''
                                    ? 'transform 7s ease-in-out'
                                    : rotateTransition,
                        }"
                    ></div>
                    <div
                        class="poiner"
                        @click="isDisabel ? pointer() : ''"
                    ></div>
                </div>
            </div>
            <!-- checkbox -->
            <template v-if="!maskSymbol">
                <div class="select">
                    <div class="logo"></div>
                    <div @click="agreeMent" class="select-box1"></div>
                    <template v-if="dotSHow">
                        <div @click="agreeMent" class="select-box2"></div>
                    </template>
                    <div class="user-read" @click="detail"></div>
                </div>
            </template>
        </template>
        <div class="footer">
            <!-- img -->
            <div class="handbag"></div>
            <div class="clothes"></div>
            <div class="phones"></div>
            <div class="clouds"></div>
        </div>
    </div>
</template>

<script>
import Rem from '../assets/rem/index';
import service from '../service/index';
import types from '@store/system/types';
export default {
    components: {},
    props: {},
    data() {
        return {
            getVerifyFlag: true,
            captchaCode: '', //验证码标识
            captchaUrl: '',
            userWrite: '', //验证码图片model,回执
            verifyFlag: false, //验证码html显示标识
            userPhone: '', //记录用户手机号
            //60s
            content: '获取验证码',
            totalTime: 60,
            canClick: true, //添加canClick
            //
            imgSrc: '',
            maskFlags: false,
            prizeF: false,
            prizeS: false,
            prizeT: false,
            prizeL: false,
            checkBox: {
                fontSize: '20px',
            },
            show: true,
            maskSymbol: false, //false
            maskStyle: {
                width: '100%',
                height: '100%',
                position: 'fixed',
                top: '0',
                left: '0',
                backgroundColor: 'rgba(0,0,0,.4)',
                zIndex: 2,
            },
            submitLock: true,
            userPhone: '', //手机号
            userVerificationCode: '',
            checked: false,
            //手机号和验证码
            sizeForm: {
                phone: '',
                code: '', //回执验证码
            },
            dotSHow: true, //小圆点
            //抽奖
            luckflag: true,
            rotateAngle: 0, //将要旋转的角度
            startRotatingDegree: 0, //初始旋转角度
            rotateTransition: '', //控制过渡效果
            click_flag: true, //是否可以旋转抽奖
            prizeArr: [],
            prize: '',
            name: '奖品8',
            isDisabel: false, //转动标志
            activityIds: '', //五位数领奖ID
            // custom: {
            //   key: "奖品8", //0元定制T恤
            //   id: 12,
            //   src: "https://act.ywbjchina.com/custom-t-shirt"
            // },
            // discounts: {
            //   key: "奖品3", //15元优惠
            //   id: 13,
            //   src: "https://act.ywbjchina.com/custom-t-shirt"
            // },
            // bag: {
            //   key: "奖品1", //10元优惠帆布包
            //   id: 14,
            //   src: "https://act.ywbjchina.com/custom-canvas-bag"
            // },
            // fiveFree: {
            //   key: "奖品6", //全场5元
            //   id: 15,
            //   src: "https://act.ywbjchina.com/custom-t-shirt"
            // },
            winId: '', //抽奖ID
            activityId: 15, //活动ID
            usedTime: {
                times: 0,
            },
            userTimesObj: {},
        };
    },
    created() {
        this.isDisabel = true;
        // console.log(this.userTimesObj.leftCount)
    },
    watch: {},
    mounted() {
        var cirle = document.querySelector('.inside-circle');
        //验证领取
        // let localVal = localStorage.getItem("userLog");
        // if (localVal) {
        //   this.isDisabel = false;
        //   alert("一个手机号码只能领取一次奖励，可以分享朋友参与抽奖");
        //   window.location.href = "https://act.ywbjchina.com/custom-t-shirt";
        // }
        // console.log(localVal)
    },
    methods: {
        getVerify2() {
            //二次验证
            //60s
            if (this.userWrite.length == 6) {
                if (!this.canClick) return; //改动的是这两行代码
                this.canClick = false;
                this.content = this.totalTime + 's后重新发送';
                let clock = window.setInterval(() => {
                    this.totalTime--;
                    this.content = this.totalTime + 's后重新发送';
                    if (this.totalTime < 0) {
                        window.clearInterval(clock);
                        this.content = '重新发送验证码';
                        this.totalTime = 60;
                        this.canClick = true; //这里重新开启
                    }
                }, 1000);
                //60秒over
                service
                    .getUserCode({
                        mobilePhone: this.userPhone,
                        smsType: 2,
                        mobileType: '+86',
                        captchaValue: this.userWrite, //二维码回执
                        captchaCode: this.captchaCode,
                    })
                    .then((res) => {
                        if (res.returnCode == 0) {
                            //二次获取验证码通过
                            // console.log("二次获取验证码", res);
                        } else {
                            alert(res.returnMessage);
                        }
                    });
                // console.log("二次点击");
            }
        },
        getVerify() {
            //获取验证码
            //一次提交
            service
                .getUserCode({
                    mobilePhone: this.userPhone,
                    smsType: 2,
                    mobileType: '+86',
                })
                .then((res) => {
                    if (res.returnCode == 0) {
                        // console.log("验证码", res);
                        this.captchaUrl = res.data.captchaUrl;
                        this.captchaCode = res.data.captchaCode;
                        if (res.data.actionType == 1) {
                            //需要验证图片时
                            this.verifyFlag = true; //input标志
                            this.getVerifyFlag = false;
                        } else if (res.data.actionType == 0) {
                            //验证码已发
                            //60s,else原为空白
                            // console.log("test1111")193346
                            if (!this.canClick) return; //改动的是这两行代码
                            this.canClick = false;
                            this.content = this.totalTime + 's后重新发送';
                            let clock = window.setInterval(() => {
                                this.totalTime--;
                                this.content = this.totalTime + 's后重新发送';
                                if (this.totalTime < 0) {
                                    window.clearInterval(clock);
                                    this.content = '重新发送验证码';
                                    this.totalTime = 60;
                                    this.canClick = true; //这里重新开启
                                }
                            }, 1000);
                            // console.log("test22222")
                        }
                    } else {
                        alert(res.returnMessage);
                    }
                });
        },
        getNow() {
            //登录接口
            service
                .getLoginUpdate({
                    mobilePhone: this.userPhone,
                    mobileType: '+86',
                    channel: 'julydraw',
                    smsCode: this.userVerificationCode,
                    smsType: 2,
                })
                .then((res) => {
                    if (res.returnCode == 0) {
                        this.$store.dispatch(
                            types.authorization,
                            res.data.token || ''
                        );
                        // 跳转领奖接口
                        service
                            .getPrizeNow({
                                activityDetailId: this.activityIds,
                                activityId: 15,
                            })
                            .then((res) => {
                                if (res.returnCode == 0) {
                                    if (this.winId == 14) {
                                        //10元帆布包
                                        localStorage.setItem('userLog', 'bag');
                                        //判断ios还是安卓
                                        // var u = navigator.userAgent;
                                        // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                                        // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
                                        // if(isiOS){
                                        //     // window.location.href = ''
                                        // }else if(isAndroid){
                                        //     // window.location.href = ''
                                        // }
                                        //判断ios还是安卓
                                        //分渠道+埋点
                                        switch (this.$route.params.source) {
                                            case 'tuiguang1 ':
                                                if (this.$route.query.falg) {
                                                    /* eslint-disable-next-line */
                                                    window._hmt.push([
                                                        '_trackEvent',
                                                        '0元定制大礼包，100%中奖等你来拿',
                                                        '市场tuiguang1渠道进入数量量 ',
                                                        window.location.href,
                                                    ]); // 百度埋点
                                                }
                                                break;
                                            case 'tuiguang2':
                                                if (this.$route.query.falg) {
                                                    /* eslint-disable-next-line */
                                                    window._hmt.push([
                                                        '_trackEvent',
                                                        '0元定制大礼包，100%中奖等你来拿',
                                                        '市场tuiguang2渠道进入数量',
                                                        window.location.href,
                                                    ]);
                                                }
                                                break;
                                            default:
                                                if (this.$route.query.falg) {
                                                    /* eslint-disable-next-line */
                                                    window._hmt.push([
                                                        '_trackEvent',
                                                        '0元定制大礼包，100%中奖等你来拿',
                                                        '市场default渠道进入数量',
                                                        window.location.href,
                                                    ]);
                                                }
                                                break;
                                        }
                                        window.location.href =
                                            'https://act.ywbjchina.com/custom-canvas-bag';
                                    } else if (this.winId == 13) {
                                        localStorage.setItem('userLog', 'swy');
                                        switch (this.$route.params.source) {
                                            case 'tuiguang1':
                                                if (this.$route.query.falg) {
                                                    /* eslint-disable-next-line */
                                                    window._hmt.push([
                                                        '_trackEvent',
                                                        '0元定制大礼包，100%中奖等你来拿',
                                                        '市场tuiguang1渠道进入数量',
                                                        window.location.href,
                                                    ]); // 百度埋点
                                                }
                                                break;
                                            case 'tuiguang2':
                                                if (this.$route.query.falg) {
                                                    /* eslint-disable-next-line */
                                                    window._hmt.push([
                                                        '_trackEvent',
                                                        '0元定制大礼包，100%中奖等你来拿',
                                                        '市场tuiguang2渠道进入数量 ',
                                                        window.location.href,
                                                    ]);
                                                }
                                                break;
                                            default:
                                                if (this.$route.query.falg) {
                                                    /* eslint-disable-next-line */
                                                    window._hmt.push([
                                                        '_trackEvent',
                                                        '0元定制大礼包，100%中奖等你来拿',
                                                        '市场default渠道进入数量',
                                                        window.location.href,
                                                    ]);
                                                }
                                                break;
                                        }
                                        window.location.href =
                                            'https://a.app.qq.com/o/simple.jsp?pkgname=com.sdo.qihang.wenbo';
                                    } else if (this.winId == 15) {
                                        //分渠道+埋点
                                        localStorage.setItem('userLog', 'wy');
                                        switch (this.$route.params.source) {
                                            case 'tuiguang1 ':
                                                if (this.$route.query.falg) {
                                                    /* eslint-disable-next-line */
                                                    window._hmt.push([
                                                        '_trackEvent',
                                                        '0元定制大礼包，100%中奖等你来拿',
                                                        '市场tuiguang1渠道进入数量',
                                                        window.location.href,
                                                    ]); // 百度埋点
                                                }
                                                break;
                                            case 'tuiguang2':
                                                if (this.$route.query.falg) {
                                                    /* eslint-disable-next-line */
                                                    window._hmt.push([
                                                        '_trackEvent',
                                                        '0元定制大礼包，100%中奖等你来拿',
                                                        '市场tuiguang2渠道进入数量',
                                                        window.location.href,
                                                    ]);
                                                }
                                                break;
                                            default:
                                                if (this.$route.query.falg) {
                                                    /* eslint-disable-next-line */
                                                    window._hmt.push([
                                                        '_trackEvent',
                                                        '0元定制大礼包，100%中奖等你来拿',
                                                        '市场default渠道进入数量',
                                                        window.location.href,
                                                    ]);
                                                }
                                                break;
                                        }
                                        window.location.href =
                                            'https://a.app.qq.com/o/simple.jsp?pkgname=com.sdo.qihang.wenbo';
                                    } else {
                                        //除10元帆布包之外的其他奖品
                                        localStorage.setItem(
                                            'userLog',
                                            'tshirt'
                                        );
                                        //判断ios还是安卓
                                        // var u = navigator.userAgent;
                                        // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                                        // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
                                        // if(isiOS){
                                        //     // window.location.href = ''
                                        // }else if(isAndroid){
                                        //     // window.location.href = ''
                                        // }
                                        //判断ios还是安卓
                                        //分渠道+埋点
                                        switch (this.$route.params.source) {
                                            case 'tuiguang1':
                                                if (this.$route.query.falg) {
                                                    /* eslint-disable-next-line */
                                                    window._hmt.push([
                                                        '_trackEvent',
                                                        '0元定制大礼包，100%中奖等你来拿',
                                                        '市场tuiguang1渠道进入数量量 ',
                                                        window.location.href,
                                                    ]); // 百度埋点
                                                }
                                                break;
                                            case 'tuiguang2':
                                                if (this.$route.query.falg) {
                                                    /* eslint-disable-next-line */
                                                    window._hmt.push([
                                                        '_trackEvent',
                                                        '0元定制大礼包，100%中奖等你来拿',
                                                        '市场tuiguang2渠道进入数量',
                                                        window.location.href,
                                                    ]);
                                                }
                                                break;
                                            default:
                                                if (this.$route.query.falg) {
                                                    /* eslint-disable-next-line */
                                                    window._hmt.push([
                                                        '_trackEvent',
                                                        '0元定制大礼包，100%中奖等你来拿',
                                                        '市场default渠道进入数量',
                                                        window.location.href,
                                                    ]);
                                                }
                                                break;
                                        }
                                        window.location.href =
                                            'https://act.ywbjchina.com/custom-t-shirt';
                                    }
                                } else {
                                    let localVal = localStorage.getItem(
                                        'userLog'
                                    );
                                    if (localVal) {
                                        this.isDisabel = false;
                                        alert(
                                            '一个手机号码只能领取一次奖励，可以分享朋友参与抽奖'
                                        );
                                        // window.location.href = "https://act.ywbjchina.com/custom-t-shirt";
                                    } else {
                                        alert(res.returnMessage);
                                    }
                                }
                            });
                    } else {
                        alert(res.returnMessage);
                        // alert("请正确填写手机号~");
                    }
                });
            //登录接口
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },
        detail() {
            this.show = !this.show;
            this.$emit('getStatus', this.show);
        },
        maskShow() {
            this.maskSymbol = !this.maskSymbol;
        },
        maskHide() {
            this.maskSymbol = !this.maskSymbol;
        },
        onSubmit() {
            // console.log("onSubmit")
        },
        agreeMent() {
            this.dotSHow = !this.dotSHow;
        },
        // 点击指针抽奖函数
        pointer() {
            if (this.dotSHow) {
                this.getlotteryPrizeFun();
            } else {
                alert('请阅读并同意文物加的活动规则');
            }
        },
        // 转动动画
        rotate(prize) {
            //目前是只转动转盘
            if (!this.click_flag) return;
            var type = 0; // 默认为 0  转盘转动
            var randCircle = 10; // 附加多转几圈，2-3
            var duringTime = 5; // 默认为 5s
            var rotateAngle = '';
            switch (this.winId) {
                // 奖品1
                case 14:
                    rotateAngle = randCircle * 360 + 45;
                    break;
                case 14: //
                    rotateAngle = randCircle * 360 + 90;
                    break;
                case 13:
                    rotateAngle = randCircle * 360 + 135;
                    break;
                case 13: //
                    rotateAngle = randCircle * 360 + 180;
                    break;
                case 13: //
                    rotateAngle = randCircle * 360 + 225;
                    break;
                case 15:
                    rotateAngle = randCircle * 360 + 270;
                    break;
                case 15: //
                    rotateAngle = randCircle * 360 + 315;
                    break;
                case 12:
                    rotateAngle = randCircle * 360 + 360;
                    break;
            }
            this.click_flag = false; // 旋转结束前，不允许再次触发
            if (type == 0) {
                // 转动盘子
                var rotateAngle =
                    this.startRotatingDegree +
                    rotateAngle -
                    (this.startRotatingDegree % 360); //将要旋转的角度
                this.startRotatingDegree = rotateAngle; //改变初始旋转的角度
                this.rotateAngle = 'rotate(' + rotateAngle + 'deg)'; //真正控制转动角度
                // 旋转结束后允许再次触发
                var self = this;
                setTimeout(() => {
                    self.click_flag = true;
                    self.isDisabel = true;
                    self.gameOver(prize); //游戏结束
                    self.maskShow(); //蒙版
                    self.maskFlags = true; //奖项标志
                    // console.log(self.maskFlags);
                }, duringTime * 1500 + 200);
            }
        },
        // 游戏结束
        gameOver() {
            // 游戏结束,重置旋转初始位置
            this.rotateAngle = 'rotate(' + 0 + 'deg)'; //真正控制转动角度的,为0,回到初始位置
            this.rotateTransition = 'transform 0.3s '; //控制转动过渡效果的
            setTimeout(() => {
                this.rotateTransition = '';
            }, 100);
            // 更新抽奖次数
            this.getActcivityFancy();
            if (this.winId == 15) {
                this.imgSrc = require('../assets/img/prizeFive.png');
            } else if (this.winId == 14) {
                this.imgSrc = require('../assets/img/prizeTen.png');
            } else if (this.winId == 13) {
                this.imgSrc = require('../assets/img/prizeFifteen.png');
            } else if (this.winId == 12) {
                this.imgSrc = require('../assets/img/prizeFree.png');
            }
        },
        // 请求活动页面数据
        getActcivityFancy() {
            service
                .getTimes({
                    activityId: this.activityId,
                })
                .then((res) => {
                    //次数 res.data.leftCount
                    console.log(res);
                    this.userTimesObj = res.data;
                    // console.log(this.userTimesObj);
                    //测试抽奖次数
                    if (this.userTimesObj.leftCount == 0) {
                        this.isDisabel = false;
                        alert('抽奖次数用尽啦');
                    } else {
                        // alert(res.returnMessage);
                    }
                    window.location.href =
                        'https://act.ywbjchina.com/custom-t-shirt';
                });
            //登录接口
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },
        detail() {
            this.show = !this.show;
            this.$emit('getStatus', this.show);
        },
        maskShow() {
            this.maskSymbol = !this.maskSymbol;
        },
        maskHide() {
            this.maskSymbol = !this.maskSymbol;
        },
        onSubmit() {
            // console.log("onSubmit")
        },
        agreeMent() {
            this.dotSHow = !this.dotSHow;
        },
        // 点击指针抽奖函数
        pointer() {
            if (this.dotSHow) {
                this.getlotteryPrizeFun();
            } else {
                alert('请阅读并同意文物加的活动规则');
            }
        },
        // 转动动画
        rotate(prize) {
            //目前是只转动转盘
            if (!this.click_flag) return;
            var type = 0; // 默认为 0  转盘转动
            var randCircle = 10; // 附加多转几圈，2-3
            var duringTime = 5; // 默认为 5s
            var rotateAngle = '';
            switch (this.winId) {
                // 奖品1
                case 14:
                    rotateAngle = randCircle * 360 + 45;
                    break;
                case 14: //
                    rotateAngle = randCircle * 360 + 90;
                    break;
                case 13:
                    rotateAngle = randCircle * 360 + 135;
                    break;
                case 13: //
                    rotateAngle = randCircle * 360 + 180;
                    break;
                case 13: //
                    rotateAngle = randCircle * 360 + 225;
                    break;
                case 15:
                    rotateAngle = randCircle * 360 + 270;
                    break;
                case 15: //
                    rotateAngle = randCircle * 360 + 315;
                    break;
                case 12:
                    rotateAngle = randCircle * 360 + 360;
                    break;
            }
            this.click_flag = false; // 旋转结束前，不允许再次触发
            if (type == 0) {
                // 转动盘子
                var rotateAngle =
                    this.startRotatingDegree +
                    rotateAngle -
                    (this.startRotatingDegree % 360); //将要旋转的角度
                this.startRotatingDegree = rotateAngle; //改变初始旋转的角度
                this.rotateAngle = 'rotate(' + rotateAngle + 'deg)'; //真正控制转动角度
                // 旋转结束后允许再次触发
                var self = this;
                setTimeout(() => {
                    self.click_flag = true;
                    self.isDisabel = true;
                    self.gameOver(prize); //游戏结束
                    self.maskShow(); //蒙版
                    self.maskFlags = true; //奖项标志
                    // console.log(self.maskFlags);
                }, duringTime * 1500 + 200);
            }
        },
        // 游戏结束
        gameOver() {
            // 游戏结束,重置旋转初始位置
            this.rotateAngle = 'rotate(' + 0 + 'deg)'; //真正控制转动角度的,为0,回到初始位置
            this.rotateTransition = 'transform 0.3s '; //控制转动过渡效果的
            setTimeout(() => {
                this.rotateTransition = '';
            }, 100);
            // 更新抽奖次数
            this.getActcivityFancy();
            if (this.winId == 15) {
                this.imgSrc = require('../assets/img/prizeFive.png');
            } else if (this.winId == 14) {
                this.imgSrc = require('../assets/img/prizeTen.png');
            } else if (this.winId == 13) {
                this.imgSrc = require('../assets/img/prizeFifteen.png');
            } else if (this.winId == 12) {
                this.imgSrc = require('../assets/img/prizeFree.png');
            }
        },
        // 请求活动页面数据
        getActcivityFancy() {
            service
                .getTimes({
                    activityId: this.activityId,
                })
                .then((res) => {
                    //次数 res.data.leftCount
                    console.log(res);
                    this.userTimesObj = res.data;
                    // console.log(this.userTimesObj);
                    //测试抽奖次数
                    if (this.userTimesObj.leftCount == 0) {
                        this.isDisabel = false;
                        alert('抽奖次数用尽啦');
                    } else {
                        // alert(res.returnMessage);
                    }
                });
        },

        //点击请求点击抽奖数据,中奖操作
        getlotteryPrizeFun() {
            if (this.click_flag) {
                this.isDisabel = true;
            }
            service
                .getPrize({
                    activityId: 15,
                    title: '抽奖活动',
                })
                .then((res) => {
                    // console.log(res);
                    if (res.returnCode == 0) {
                        if (this.isDisabel && this.times !== 0) {
                            // console.log(res);
                            this.winId = JSON.parse(res.data.extendData).id;
                            this.prize = JSON.parse(
                                res.data.extendData
                            ).awardsName;
                            this.activityIds = JSON.parse(res.data.id); //领奖跳转的ID
                            // console.log(this.activityIds);
                            this.rotate(this.prize); //转动
                            this.isDisabel = false;
                        }
                    } else {
                        alert(res.returnMessage);
                    }
                });
        },
    },
    watch: {},
};
</script>

<style lang="scss" scoped>
@import '../assets/css/turnTable.scss';
</style>
